import React from 'react';
import Card from '../general/card/card.component';
import "./Homepage.css";
import Header from '../general/Headers/Header';
import Footer from '../general/Footer/Footer';
import Feedback from './Alumni-feedback';
import SlidingTab from './SlidingTab';
import Grid from '@mui/material/Grid';
// import Padding from '../general/padding/Padding';
import Divider from '@mui/material/Divider';


function Homepage() {

    const content= [
        [
        ["To enhance and equip our students with the conceptualized employability and professional skills in meeting the dynamic challenges of the corporate world"],

        ["To acquaint our faculty members with current industrial trends,We have excellent infrastructure facilities in terms of full-fledged seminar hall, training hall, conference and board rooms, interview cabins, full-fledged computer labs ."],
        ],
         [  
             ["To train the students to meet the industry requirements."],
            ["To guide the students to achieve their career goals."],
            ["To provide ample placement opportunities for the students to get their dream jobs."],
            ["To equip our faculty members with the latest industry requisites."]
            
        ],
        [  ["To enhance industry-institute interaction."],
            ["To organize seminar, training programmes and work-shops for students so as to  help students to learn latest technologies"],
            ["To organize seminars, technical talks by eminent   personalities from academic institutes and industry to enhance the awareness of students."],
            ["To provide guidance and information for higher studies."],
            ["To conduct mock tests, interviews, Group Discussions for students."],
            ["To conduct training programs to enhance the communication skills and develop inter-personal skills of students."],
            ["To arrange campus-interviews by inviting leading companies to recruit students."]
        
        ],


    ]

       
    return (
         <container container spacing={2} justifyContent="center" >
        {/*  header */}
        <Header />
       {/* image */}
       
        <Grid item className="landing-page" lg={12} md={12}>
            <h1 className='title-main'>PLACEMENT CELL</h1>
            <h2 className='title-sub'>BANGALORE INSTITUTE OF TECHNOLOGY</h2>
        </Grid>
 
        {/* vision card  mission card */}

        <div id='mission-vision'>
        {/* <Card  
                title="Vision" 
                content={content[0]}></Card>  */}

        <Grid item className='Vision-card' display='flex'>
        <Card className="card" sx={{height:300}} 
                title="Vision" 
                content={<ul>
                <li>{content[0][0]}</li>
                <li>{content[0][1]}</li>
              

              </ul>}></Card>
                
          </Grid> 

          <Grid item className='Mission-card' display='flex'>    
        <Card className="card"  sx={{height:300}} 
// >>>>>>> 7c8d10fc88df6dcb6cdfb9c652b495ff5e5501d2:src/components/homepage/Homepage.jsx
                title="Mission"
                content={<ul>
                            <li>{content[1][0]}</li>
                            <li>{content[1][1]}</li>
                            <li>{content[1][2]}</li>
                            <li>{content[1][3]}</li>
                        </ul>}></Card>
                        </Grid>
{ /* <<<<<<< HEAD:src/components/Home/Homepage.jsx */}
    </div>
        
        {/* objectives card */}
        <Grid item className='Objectives' align='center'>
        <Card className="objective card" bigCardDisplay title="Objectives" content={
        <ul style={{textAlign:'justify'}}>
                            <li>{content[2][0]}</li>
                            <li>{content[2][1]}</li>
                            <li>{content[2][2]}</li>
                            <li>{content[2][3]}</li>
                            <li>{content[2][4]}</li>
                            <li>{content[2][5]}</li>
                            <li>{content[2][6]}</li>
                        </ul>} ></Card>
        </Grid>
        {/* Sliding tabs */}
        <div> 
        <Divider />
        <Divider />
        <Divider />
        <SlidingTab />
        <Divider />
        <Divider />
        <Divider />
        </div>
        {/* Alumni feedback */}
        <Grid item lg={12} md={12}>
        <Feedback />
        </Grid>
        {/* footer */}
        <Grid item lg={12} md={12}>
        <Footer />
        </Grid>
      </container> 
        
    )
}

export default Homepage;